module.exports = __webpack_public_path__ + "static/media/whatsApp.cccd988e.png";